'use client';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { mdxComponents } from './mdx-components';
import { proseClassName } from './proseClassName';

interface MarkdownContentProps {
  content: string; // Markdown string from database
}

export function MarkdownContent({ content }: MarkdownContentProps) {
  return (
    <article className={proseClassName}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={mdxComponents as any}
      >
        {content}
      </ReactMarkdown>
    </article>
  );
}
